import axios           from "axios";
import _error          from "_common/error";
import logger          from "_common/logger";
import { APP_VERSION } from "_config/index";
import { DEVICE_TYPE } from "_config/index";
import Toast           from "_common/toast";
import { getDeviceId } from "_common/utils/user";
import { getUserData } from "_common/utils/user";

const log = logger ( { file: "common/xhr" } );

let called = false;

const axiosInterceptor = () => {
	called = true;

	axios.interceptors.response.use (
		response => {
			return response;
		},
		async error => {
			if ( error && error.response && ( error.response.status === 401 || error.response.status === 426 ) ) {
				if ( error?.response?.config?.url ) {
					if ( !process.browser )
						throw new Error ( "TOKEN_EXPIRED", { cause: error } );

					const urlParams = new URL ( error?.response?.config?.url );

					// Force logout
					const forceLogout = urlParams.pathname === "/user-profile/logout";

					window.location.replace ( `/logout?forceLogout=${ forceLogout }&prevLocation=${ window.location.pathname }` );
				}

				Toast.warn ( "Session expired. Please reload the page." );
			}

		    throw error;
		}
	);
};

if ( !called )
	axiosInterceptor ();

const getHeaders = function ( headers ) {
	const deviceId  = this?.customHeaders?.deviceId || getDeviceId ();
	const authToken = this?.customHeaders?.token || getUserData ()?.accessToken;

	return {
		...headers,
		"device-type"   : DEVICE_TYPE,
		"app-version"   : APP_VERSION,
		"device-id"     : deviceId,
		"authorization" : authToken
	};
};

const get = async function ( { headers = {}, url, params }, options = {} ) {
	try {
		const __headers = options?.noHeaders ? {} : getHeaders.bind ( this ) ( headers );

		if ( !__headers.authorization && !options?.noHeader )
			throw "no token created yet";

		const response = await axios ( {
			url,
			method  : "get",
			timeout : 20000,
			headers : options?.noHeaders ? headers : __headers,
			params
		} );

		if ( !options.emptyResponse && ( !response || !response.data ) )
			throw "data not available";

		return response.data;
	} catch ( error ) {
		log.error ( { error, url }, "Error making API call." );
		throw _error ( error );
	}
};

const post = async function ( { headers = {}, url, transform, data, timeout = 20000, config = {} } ) {
	try {
		const __headers = getHeaders.bind ( this ) ( headers );

		if ( !__headers.authorization )
			throw "no token created yet";

		const response = await axios ( {
			url,
			timeout,
			method            : "post",
			headers           : __headers,
			transformResponse : transform,
			data,
			...config
		} );

		if ( !response || !response.data )
			throw "data not available";

		return response.data;
	} catch ( error ) {
		log.error ( { error, url }, "Error making API call." );
		throw _error ( error );
	}
};

const put = async function ( { headers = {}, url, transform, data, timeout = 0 } ) {
	try {
		const __headers = getHeaders.bind ( this ) ( headers );

		if ( !__headers.authorization )
			throw "no token created yet";

		const response = await axios ( {
			url,
			timeout,
			method            : "put",
			headers           : __headers,
			transformResponse : transform,
			data
		} );

		if ( !response || !response.data )
			throw "data not available";

		return response.data;
	} catch ( error ) {
		log.error ( { error, url }, "Error making API call." );
		throw _error ( error );
	}
};

export default {
	get,
	post,
	put
};
